import { render, staticRenderFns } from "./predictionCategory.vue?vue&type=template&id=1cc215da&scoped=true"
import script from "./predictionCategory.vue?vue&type=script&lang=js"
export * from "./predictionCategory.vue?vue&type=script&lang=js"
import style0 from "./predictionCategory.vue?vue&type=style&index=0&id=1cc215da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc215da",
  null
  
)

export default component.exports